'use client';

import styles from './sidebar.module.css';
import { useAppSelector } from '@/app/lib/store/hooks';
import { useEffect, useState } from 'react';
import AnimatedHamburger from '../header/animated-hamburger';
import { Box, ScrollArea } from '@radix-ui/themes';
import SidebarNavigationContainer from './sidebar-navigation-container';

export default function Sidebar() {
  const isOpen = useAppSelector(state => state.drawer.isOpen);

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      document.body.classList.add('noscroll');
    } else {
      setTimeout(() => setVisible(false), 300); // Ждем окончания анимации перед скрытием
      document.body.classList.remove('noscroll');
    }
  }, [isOpen]);

  return (
    <Box display={{ initial: 'block', md: 'none' }}>
      {visible && (
        <div
          className={`${styles.Content} ${
            isOpen ? styles.Visible : styles.Removed
          }`}
        >
          <div className={styles.ButtonContainer}>
            <AnimatedHamburger />
          </div>
          <ScrollArea
            size='1'
            radius='full'
            type='auto'
            scrollbars='vertical'
          >
            <SidebarNavigationContainer />
          </ScrollArea>
        </div>
      )}
    </Box>
  );
}
